import styled from 'styled-components';

import { Navigate, useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { SearchLayoutRoot } from '@sorare/core/src/components/search/SearchLayout/ui';
import { ANY_SPORT_MY_CARDS_GALLERY } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { CollectionNavigationSwitch } from 'components/myCards/CollectionNavigationSwitch';
import { LeagueCollectionPreview } from 'components/myCards/LeagueCollectionPreview';

import type { PageParams } from './__generated__/routeParams';

const Root = styled(Vertical)`
  padding: var(--double-unit) 0;
`;

const FOOTBALL_LEAGUES = [
  'premier-league-gb-eng',
  'ligue-1-fr',
  'laliga-es',
  'bundesliga-de',
];

const GalleryTypePage = () => {
  const { rarity, set } = useTypedParams<PageParams>();
  const { currentUser } = useCurrentUserContext();
  const { generateSportContextPath } = useSportContext();
  if (!isRarityStr(rarity)) {
    return (
      <Navigate to={generateSportContextPath(ANY_SPORT_MY_CARDS_GALLERY)} />
    );
  }
  return (
    <SearchLayoutRoot>
      <Root gap={2}>
        <Horizontal>
          {!!currentUser && (
            <CollectionNavigationSwitch
              user={currentUser}
              rarity={Rarity.common}
            />
          )}
        </Horizontal>
        {FOOTBALL_LEAGUES.map(league => (
          <LeagueCollectionPreview
            key={league}
            setSlug={set}
            leagueSlug={league}
            rarity={rarity}
            userSlug={currentUser?.slug || ''}
          />
        ))}
      </Root>
    </SearchLayoutRoot>
  );
};
export default GalleryTypePage;
